import React, {useState, useRef} from 'react';
import {TopBar} from '@shopify/polaris';
import {SearchProvider} from '@thinkwell/react.common';
import {AppProvider} from '@thinkwell/react.polaris';
import { CourseProvider } from '../contexts/Course'
import Course from './Course'
import EditCourse from './EditCourse'
import MainFrame from '../MainFrame';

export default function Show(props) {
  const navigateToRef = useRef()
  const [search, setSearch] = useState()
  const [addCourseActive, setAddCourseActive] = useState(false);
  const [isCourseMenuOpen, setIsCourseMenuOpen] = useState(false);
  const toggleIsCourseMenuOpen = () => setIsCourseMenuOpen((isCourseMenuOpen) => !isCourseMenuOpen);

  const courseMenuMarkup = (
     <TopBar.UserMenu
       actions={[
         {
           items: [
             {content: 'Add Course', onAction: () => { setAddCourseActive(true) }},
             {content: 'Logout', url: '/logout'}
           ]
         }
       ]}
       name="Courses"
       initials="C"
       open={isCourseMenuOpen}
       onToggle={toggleIsCourseMenuOpen}
     />
   );

  const onSearchKeyPress = (event) => {
    const enterKeyPressed = event.keyCode === 13;
    if (enterKeyPressed) {
      event.preventDefault();
      navigateToRef.current(`courses?q=${encodeURIComponent(search)}`)
    }
  }

  const onSearchChange = (value) => {
    setSearch(value)
  }

  const onAddCourse = (course) => {
    navigateToRef.current(`courses/${course.id}`)
  }

  const onDeleteCourse = (course) => {
    navigateToRef.current(`courses`)
  }

  return (
  <AppProvider>
    <SearchProvider>
      <MainFrame searchPlaceHolder={props.item.name} onSearchChange={onSearchChange}
      onSearchKeyPress={onSearchKeyPress} navigateToRef={navigateToRef} userMenu={courseMenuMarkup}>
        <CourseProvider value={props.item}>
          { addCourseActive ?
            <EditCourse
              active={addCourseActive}
              onActive={(active) => { if (active != addCourseActive) { setAddCourseActive(active) }}}
              onSave={onAddCourse}
            /> : null
          }
          { !addCourseActive ?
            <Course
              onDelete={onDeleteCourse}
              navigateToRef={navigateToRef} /> : null
          }
        </CourseProvider>
      </MainFrame>
    </SearchProvider>
  </AppProvider>)
}
